export const openInNewTab = (url) => {
    // const newWindow = window.open(url, '_blank')
    // if (newWindow) newWindow.opener = null
    const win = window.open(url, '_blank');
    win.focus();
}